import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import _ from 'lodash';

const viewKey = 'FORM_QUICK_REFERENCE';
export default function relatedDocumentsReducer(state = initialstate.relatedDocuments, action) {
	switch (action.type) {
		case types.GET_ALL_RELATED_DOCUMENTS:
		case types.GET_ALL_RELATED_DOCUMENTS_FOR_BODIES:
			return action.response || state;
		case types.DELETE_DOCUMENT_BY_ID:
			if (action.viewKey === viewKey) {
				return {
					...state,
					data: state.data.filter((document) => {
						return !(document.id === action.documentId);
					})
				};
			} else {
				return state;
			}
		case types.UPDATE_DOCUMENT:
			if (action.viewKey === viewKey && action && !action.error) {
				const updatedDocumentIndex = state.data.findIndex((document) => {
					return document.id === action.documentId;
				});

				let updatedDocument = _.cloneDeep(state.data[updatedDocumentIndex]);
				updatedDocument = {...updatedDocument, ...action.meta.api.data};

				const newData = [...state.data];
				newData[updatedDocumentIndex] = updatedDocument;

				return {...state, data: newData};
			} else {
				return state;
			}
		case types.POST_RNH_NEW_NOTE: {
			if (action.noteInfo?.viewKey === viewKey && action.noteInfo?.documentId) {
				const documentId = action.noteInfo.documentId;
				const updatedDocumentIndex = state.data.findIndex((document) => document.id === documentId);

				if (updatedDocumentIndex > -1) {
					const newDocument = {...state.data[updatedDocumentIndex]};
					newDocument.engagementReviewNoteCount = (newDocument.engagementReviewNoteCount || 0) + 1;

					const newData = [...state.data];
					newData[updatedDocumentIndex] = newDocument;

					return {
						...state,
						data: newData
					};
				}

				return state;
			} else {
				return state;
			}
		}
		case types.UPDATE_RNH_NOTE_DETAIL: {
			if (
				action.commentData?.viewKey === viewKey &&
				action.commentData?.documentId &&
				action.commentData?.statusIdChanged
			) {
				const documentId = action.commentData.documentId;
				const updatedDocumentIndex = state.data.findIndex((document) => document.id === documentId);

				if (updatedDocumentIndex > -1) {
					const newDocument = {...state.data[updatedDocumentIndex]};

					if (action.commentData.isOpening || action.commentData.isClosing) {
						newDocument.engagementReviewNoteCount =
							(newDocument.engagementReviewNoteCount || 0) + (action.commentData.isOpening ? 1 : -1);
					}

					const newData = [...state.data];
					newData[updatedDocumentIndex] = newDocument;

					return {
						...state,
						data: newData
					};
				}

				return state;
			} else {
				return state;
			}
		}
		case types.CREATE_RELATED_DOCUMENT:
			return action.response || state;
		case types.DELETE_RELATED_DOCUMENT:
			return action.response || state;
		case types.CHECK_IN_CHECK_OUT_DOCUMENT: {
			if (action?.responseObj?.data && Object.keys(state).length > 0) {
				var docStatusId =
					action.responseObj.data?.versions &&
					action.responseObj.data.versions.length > 0 &&
					action.responseObj.data.versions.find((version) => version?.isCurrentVersion === true)?.documentStatusId;

				if (state?.data) {
					let relatedDocuments = _.cloneDeep(state.data);

					if (!Array.isArray(relatedDocuments)) {
						relatedDocuments = [relatedDocuments];
					}

					let currentDocument = relatedDocuments.find((document) => document.id === action.documentId);

					if (currentDocument) {
						currentDocument.documentStatusId = docStatusId;
					}

					return {
						...state,
						data: relatedDocuments
					};
				}
			}
			return state;
		}
		case types.ADD_APPROVAL: {
			const docId = action?.responseObj?.data?.documentId;
			if (docId) {
				const newApproval = action.responseObj.data;
				const newData = state?.data?.map((document) => {
					if (document.id === docId) {
						return {
							...document,
							approvals: Array.isArray(document.approvals)
								? [...document.approvals, newApproval]
								: [newApproval]
						};
					}
					return document;
				});
				return {
					...state,
					data: newData
				};
			}
			return state;
		}
		case types.DELETE_APPROVAL: {
			const docId = action?.meta?.api?.data?.documentId;
			const approvalIdToDelete = action?.meta?.api?.data?.approvalId;
			if (docId && approvalIdToDelete) {
				const newData = state?.data?.map((document) => {
					if (document.id === docId) {
						return {
							...document,
							approvals: Array.isArray(document.approvals)
								? document.approvals.filter(app => app.id !== approvalIdToDelete)
								: []
						};
					}
					return document;
				});
				return {
					...state,
					data: newData
				};
			}
			return state;
		}
		default:
			return state;
	}
}
